import { render, staticRenderFns } from "./project-group-game-set.vue?vue&type=template&id=6b880134&scoped=true"
import script from "./project-group-game-set.vue?vue&type=script&lang=js"
export * from "./project-group-game-set.vue?vue&type=script&lang=js"
import style0 from "./project-group-game-set.vue?vue&type=style&index=0&id=6b880134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b880134",
  null
  
)

export default component.exports